export default `
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" preserveAspectRatio="xMidYMid meet" viewBox="0 0 64 40" width="64" height="40">
  <defs>
      <path d="M25.85 39.95L25.85 27.88L6.74 39.69L25.85 39.95Z" id="a2frqTFOCi" />
      <path d="M0 26.17L0 36.05L17.58 26.27L0 26.17Z" id="a10fnOQc0B" />
      <path d="M26.01 0.03L26.01 12.36L6.83 0.16L26.01 0.03Z" id="ao2C22CM1" />
      <path d="M0 15L0 4.81L17.69 14.89L0 15Z" id="b4FqbyxNO" />
      <path d="M38 40.17L38 27.77L57.18 39.9L38 40.17Z" id="bjObM67Ms" />
      <path d="M64 26.09L64 36.03L46.32 26.2L64 26.09Z" id="blOYDLHbL" />
      <path d="M37.98 0.03L37.98 12.2L56.91 0.16L37.98 0.03Z" id="e1TnN3V02" />
      <path d="M64 15L64 4.81L46.31 14.89L64 15Z" id="c3Tcd9AeRh" />
      <path d="M0 18.06L64 18.06L64 22.78L0 22.78L0 18.06Z" id="d6HOqEZN3" />
      <path d="M34.6 0L34.6 40.13L29.6 40.13L29.6 0L34.6 0Z" id="a1bQTbAWug" />
  </defs>
  <g>
      <g><use xlink:href="#a2frqTFOCi" /></g>
      <g><use xlink:href="#a10fnOQc0B" /></g>
      <g><use xlink:href="#ao2C22CM1" /></g>
      <g><use xlink:href="#b4FqbyxNO" /></g>
      <g><use xlink:href="#bjObM67Ms" /></g>
      <g><use xlink:href="#blOYDLHbL" /></g>
      <g><use xlink:href="#e1TnN3V02" /></g>
      <g><use xlink:href="#c3Tcd9AeRh" /></g>
      <g><use xlink:href="#d6HOqEZN3" /></g>
      <g><use xlink:href="#a1bQTbAWug" /></g>
  </g>
</svg>`